export default (values) => {
  const errors = {}
  const { type, file, scheduleId } = values

  if (!type) {
    errors.type = 'Type must not be empty'
  }

  if (!scheduleId) {
    errors.scheduleId = 'Schedule id must not be empty'
  }

  if (typeof file === 'undefined' || file === '') {
    errors.file = 'File must not be empty'
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/imports-form/validate.js